var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import Grid from '../Grid';
import BaseIllustration from './BaseIllustration';
import Text from '../Text';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = (theme) => createStyles({
    containerIllustration: {
        alignItems: 'center',
        display: 'flex'
    },
    containerIllustrationFluid: {
        alignItems: 'center',
        display: 'flex',
        height: Tokens.heightFluid
    },
    containerIllustrationLg: {
        [theme.breakpoints.up('sm')]: {
            minHeight: '450px'
        },
        minHeight: '350px'
    },
    containerIllustrationMd: {
        [theme.breakpoints.up('sm')]: {
            minHeight: '300px'
        },
        minHeight: '250px'
    },
    containerIllustrationSm: {
        [theme.breakpoints.up('sm')]: {
            minHeight: '200px'
        },
        minHeight: '150px'
    },
    containerIllustrationXs: {
        minHeight: '100px'
    },
    textIllustrationLg: {
        marginTop: Tokens.spacing50
    },
    textIllustrationMd: {
        marginTop: Tokens.spacing40
    },
    textIllustrationSm: {
        marginTop: Tokens.spacing30
    }
});
const Illustration = (props, ref) => {
    const { classes, height, noHeightFluid, text } = props, rest = __rest(props, ["classes", "height", "noHeightFluid", "text"]);
    let classContainer = noHeightFluid ? classes.containerIllustration : classes.containerIllustrationFluid;
    let classText;
    let spacing;
    if (height) {
        switch (height) {
            case 'xs':
                classContainer = classnames(classContainer, classes.containerIllustrationXs);
                spacing = 0;
                break;
            case 'sm':
                classContainer = classnames(classContainer, classes.containerIllustrationSm);
                classText = classes.textIllustrationSm;
                spacing = 1;
                break;
            case 'md':
                classContainer = classnames(classContainer, classes.containerIllustrationMd);
                classText = classes.textIllustrationMd;
                spacing = 1;
                break;
            case 'lg':
                classContainer = classnames(classContainer, classes.containerIllustrationLg);
                classText = classes.textIllustrationLg;
                spacing = 2;
                break;
        }
    }
    return (React.createElement("div", { className: classContainer, ref: ref },
        React.createElement(Grid, { container: true, alignItems: "center", direction: "column", justifyContent: "center", spacing: spacing, wrap: "nowrap" },
            React.createElement(Grid, { item: true },
                React.createElement(BaseIllustration, Object.assign({}, rest))),
            React.createElement(Grid, { item: true, xs: 12, sm: 8, md: 4 },
                React.createElement(Text, { className: classText, align: "center" }, text)))));
};
const IllustrationFRC = forwardRef(Illustration);
IllustrationFRC.displayName = 'CardFRC';
IllustrationFRC.defaultProps = {
    height: 'lg',
    text: ''
};
export default withStyles(styles, { name: 'IllustrationWS' })(IllustrationFRC);
